<template>
  <div class="wrap-index">
    <loading v-if="loadingBool" />
      <!--首页banner-->
      <div class="index-banner" v-else>
          <swiper :options="bannerOptions" ref="bannerSwiper" v-if="bannerList.length">
              <swiper-slide v-for="(item,i) in bannerList" :key="i">
                  <div class="swiper-item" :style="'background:url('+item.blur_img_id+') no-repeat center center;background-size:130% 130%'">
                  </div>
                  <img :src="item.image_id" class="banner-img">
              </swiper-slide>
          </swiper>
          <!--缩略图-->
          <div class="banner-swiper-pagination inner">
              <div class="pagination-bullet" @mouseover="changeSlide(i)" v-for="(item,i) in bannerList" :key="i" :style="'background:url('+item.image_id+') no-repeat center center;background-size:100% 100%'">
              </div>
          </div>
      </div>
      <!--娱情一线-->
      <div id="news" class="index-news inner  animated fadeInUp">
          <div class="common-title">
              <h3 class="ch">娱情一线</h3>
              <p class="en">Entertainment scene</p>
          </div>
          <div class="news-wrap">
              <ul class="news-list">
                  <li v-for="(item,i) in newsList" :key="i">
                      <router-link :to="'/hotcontent/'+item.id">
                          <div class="cover">
                              <img :src="item.picture">
                          </div>
                          <div class="news-info">
                              <p class="name">{{item.title}}</p>
                              <p class="desc" v-html="item.intro"></p>
                              <p class="author">
                                  作者  艺人之家
                                  <span class="time">{{item.create_time}}</span>
                              </p>
                          </div>
                      </router-link>
                  </li>
              </ul>
              <div class="hot-recommend">
                  <div class="new-list">
                      <h3 class="title">推荐新闻<router-link to="/hot">查看更多>></router-link></h3>
                      <ul class="list">
                          <li v-for="(item,i) in recommendJournalism" :key="i">
                              <router-link :to="'/hotcontent/'+item.id">
                                  <span class="number" :class="i<3?'red':'yellow'">{{i+1}}</span>
                                  <span class="item-title">{{item.title}}</span>
                                  <span class="views">{{item.hot}}<i class="icon" v-show="i<3"></i></span>
                              </router-link>
                          </li>
                      </ul>
                  </div>
                  <div class="show-list">
                      <h3 class="title">艺人展示<router-link to="/baike">查看更多>></router-link></h3>
                      <div class="show-banner">
                          <swiper :options="showOptions" ref="showOptions">
                              <swiper-slide v-for="(item,i) in artistShow" :key="i">
                                  <img :src="item.picture">
                              </swiper-slide>
                          </swiper>
                          <div class="swiper-button-next"></div>
                          <div class="swiper-button-prev"></div>
                      </div>
                  </div>
              </div>
          </div>
          <router-link to="/hot" class="more-btn">查看更多</router-link>
      </div>

      <!--娱人工访-->
      <div id="views" :class="fadeIn==1?'animated fadeInUp':''" class="index-views inner">
          <div class="common-title">
              <h3 class="ch">娱人工访</h3>
              <p class="en">Artist interview</p>
          </div>
          <div class="views-wrap">
              <div class="views-list">
                  <div class="top">
                      <div class="top-left" v-for="(item,i) in videoImg" v-if="i==0">
                          <router-link :to="'/videocontent/'+item.id">
                              <div class="cover">
                                  <img :src="item.picture">
                              </div>
                              <div class="top-left-info">
                                  <h3 class="name">{{item.title}}</h3>
                                  <p class="desc">{{item.intro}}</p>
                              </div>
                          </router-link>
                      </div>
                      <div class="top-right">
                          <div class="item" v-for="(item,i) in videoImg" v-if="i<3 && i!=0">
                              <router-link :to="'/videocontent/'+item.id">
                                  <div class="cover">
                                      <img :src="item.picture">
                                  </div>
                                  <div class="item-info">
                                      <h3 class="name">{{item.title}}</h3>
                                      <p class="desc">{{item.intro}}</p>
                                  </div>
                              </router-link>
                          </div>
                      </div>
                  </div>
                  <ul class="bottom">
                      <li v-for="(item,i) in videoImg" :key="i" v-if="i>2">
                          <router-link :to="'/videocontent/'+item.id">
                              <div class="cover">
                                  <img :src="item.picture">
                              </div>
                              <p class="name">{{item.title}}</p>
                          </router-link>
                      </li>
                  </ul>
              </div>
              <div class="hot-views">
                  <div class="video-list">
                      <h3 class="title">推荐专访<router-link to="/video">查看更多>></router-link></h3>
                      <ul class="list">
                          <li v-for="(item,i) in recommendInterview.slice(0,7)">
                              <router-link :to="'/videocontent/'+item.id">
                                  <span class="number" :class="i<3?'red':'yellow'">{{i+1}}</span>
                                  <div class="cover">
                                      <img :src="item.picture" />
                                  </div>
                                  <div class="desc">{{item.title}}</div>
                                  <span class="views">{{item.hot}}<i class="icon" v-show="i<3"></i></span>
                              </router-link>
                          </li>
                      </ul>
                  </div>
              </div>
          </div>
          <router-link to="/video" class="more-btn">查看更多</router-link>
      </div>

      <!--关于我们-->
      <div id="about" :class="fadeIn==2?'animated fadeInUp':''" class="index-about">
          <div class="inner">
              <div class="common-title">
                  <h3 class="ch">关于我们</h3>
                  <p class="en">About us</p>
                  <p class="desc">亚洲艺人之家 是华誉传奇影业旗下全媒体娱乐营销平台与艺人经纪平台，拥有全媒体营销矩阵，线下杂志，幕后有着强大的内容策划团队、媒体营销团队、视觉制作团队。为娱乐圈艺人、机构、影视宣传提供专业的营销推广。同时打造属于自己的专业的艺人梯队， 亚洲艺人之家致力于打造互联网全方面的娱乐营销平台!</p>
              </div>
              <ul class="plate">
                  <li>
                      <div class="circle">
                          <img src="../assets/images/icon-Browser.png"/>
                      </div>
                      <h3 class="name">娱乐营销</h3>
                      <p class="txt">顶级策划团队，雄厚媒体资源，借力打力，以巧取胜</p>
                  </li>
                  <li>
                      <div class="circle">
                          <img src="../assets/images/icon-Camera.png"/>
                      </div>
                      <h3 class="name">艺人推广</h3>
                      <p class="txt">
                          实时动态监控，把牢舆情方向，热点策源
                      </p>
                  </li>
                  <li>
                      <div class="circle">
                          <img src="../assets/images/icon-iPhone.png"/>
                      </div>
                      <h3 class="name">
                          影视宣传
                      </h3>
                      <p class="txt">
                          深挖艺人亮点，定制成长方案，量身打造，保驾护航
                      </p>
                  </li>
                  <li>
                      <div class="circle">
                          <img src="../assets/images/icon-vip.png"/>
                      </div>
                      <h3 class="name">
                          艺人经纪
                      </h3>
                      <p class="txt">
                          全媒介战略合作，大矩阵个性投送，分众传媒，病毒传播
                      </p>
                  </li>

              </ul>
          </div>
      </div>

      <!--合作伙伴-->
      <div id="partner" :class="fadeIn==3?'animated fadeInUp':''" class="index-partner inner">
          <div class="common-title">
              <h3 class="ch">合作伙伴</h3>
              <p class="en">Partner</p>
          </div>
          <div class="partenr-banner">
              <swiper :options="partnerOptions" ref="partnerOptions">
                  <swiper-slide v-for="(item,i) in partnersUrl" :key="i">
                      <img :src="item.url">
                      <p class="name">{{item.name}}</p>
                  </swiper-slide>
              </swiper>
          </div>
      </div>
  </div>
</template>

<script>
    // import { swiper, swiperSlide } from 'vue-awesome-swiper';
    import loading from './loading'

    export default {
        name:"Index",
        components:{
            // swiper,
            // swiperSlide
            loading
        },
        data(){
            return{
              loadingBool: true,
                bannerOptions:{
                    speed:2000,
                    effect: 'fade',
                    autoplay:true,
                    slidesPerView: 1,
                },
                partnerOptions:{
                    slidesPerView: 8,
                    slidesPerColumn: 2,
                    spaceBetween: 30,
                    autoplay: {
                        delay:2000,
                    },
                    speed: 1000,
                    loop: true,
                    autoplayDisableOnInteraction: false,
                    observer:true,//修改swiper自己或子元素时，自动初始化swiper
                    observeParents:true,//修改swiper的父元素时，自动初始化swiper
                },
                showOptions:{
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    autoplay: {
                        delay:2000,
                    },
                    speed: 1000,
                    loop: true,
                    slidesPerView: 1,
                    autoplayDisableOnInteraction: false,
                    observer:true,//修改swiper自己或子元素时，自动初始化swiper
                    observeParents:true,//修改swiper的父元素时，自动初始化swiper
                },
                bannerList:[],//轮播
                newsList:[],//娱情一线
                videoImg:[],//艺人专访
                partnersUrl:[],//合作伙伴
                recommendJournalism:[],//推荐新闻
                artistShow:[],//艺人展示
                recommendInterview:[],
                fadeIn:0,
                column_title:'',
                column_keywords:'',
                column_description:''
            }
        },
        metaInfo() {
            return {
                title: this.column_title  + '-打造影视行业优秀的资源聚合服务平台'  || '',
                meta: [{
                    name: 'keywords',
                    content: this.column_keywords
                },
                    {
                        name: 'description',
                        content: this.column_description
                    }
                ]
            }
        },
        computed: {
            swiper() {
                return this.$refs.bannerSwiper.swiper
            }
        },
        methods:{
            //seo接口
            getSeo() {
                let seoApi = 'https://api.yopoo.cn/api/v1/getweb'
                this.$http.get(seoApi)
                    .then((res) => {
                        let seoList = res.body
                        this.column_keywords = seoList.webdescription
                        this.column_keywords = seoList.webkeywords
                        this.column_title = seoList.webtitle
                    }, err => {
                        console.log(err)
                    })
            },
            changeSlide(i){
                this.swiper.slideTo(i)
            },
            handleScroll () { //改变元素#searchBar的top值
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                if(scrollTop > 400 && scrollTop<1450){
                    this.fadeIn = 1
                }else if(scrollTop > 1450 && scrollTop<1980){
                    this.fadeIn = 2
                }else if(scrollTop > 1980){
                    this.fadeIn = 3
                    window.removeEventListener('scroll', this.handleScroll)
                }
            }
        },
        created(){
            this.getSeo()
            var api = 'https://api.yopoo.cn/api/v1/homepage'
            this.$http.get(api).then((res) => {
                   this.loadingBool = false
                   let result = res.data.data || {}
                   this.bannerList = result.carousel || [];
                   this.partnersUrl = result.partnersUrl || [];
                   this.newsList = result.entertainmentNews || [];
                   this.recommendJournalism = result.recommendJournalism || [];
                   this.artistShow = result.artistShow ||[];
                   this.videoImg = result.videoImg || [];
                   this.recommendInterview = result.recommendInterview || []
                },
                err => {
                    console.log(err)
                }
            )
        },
        mounted () {//给window添加一个滚动滚动监听事件
            window.addEventListener('scroll', this.handleScroll)
        },
        destroyed () {//离开该页面需要移除这个监听的事件
            window.removeEventListener('scroll', this.handleScroll)
        },
  }
</script>

<style lang="less" rel="stylesheet/less">
  .wrap-index{
      line-height: 0;
      font-size: 0;
      .common-title{
          padding: 40px 0;
          box-sizing: border-box;
          text-align: center;
          color: #333;
          .ch{
              font-size: 28px;
              height: 28px;
              line-height: 28px;
          }
          .en{
              font-size: 16px;
              padding-top: 10px;
              height: 16px;
              line-height: 16px;
          }
          .desc{
              font-size: 14px;
              line-height: 20px;
              text-align: center;
              color: #fff;
              padding-top: 20px;
          }
      }
      .inner{
          width: 1200px;
          display: block;
          margin: 0 auto;
          overflow: hidden;
      }
      .more-btn{
          display: block;
          width: 120px;
          height: 36px;
          line-height: 36px;
          background: #000;
          color: #fff;
          border-radius: 3px;
          font-size: 16px;
          text-align: center;
          margin: 50px auto;
      }

      .index-banner{
          width: 100%;
          height: 360px;
          overflow: hidden;
          position: relative;
          &:hover{
              .banner-swiper-pagination{
                  display: block;
              }
          }
          .swiper-container{
              height: 360px;
              .swiper-slide{
                  position: relative;
                  width: 100% !important;
              }
          }
          .swiper-item{
              height: 360px;
              position: relative;
          }
          .swiper-item:after{
              content: "";
              width: 100%;
              height: 160%;
              position: absolute;
              left: 0;
              top: -97px;
              background: inherit;
              -webkit-filter: blur(60px);
              filter: blur(60px);
          }
          .banner-img{
              position: absolute;
              left: 50%;
              margin-left: -600px;
              height: 100%;
              width: 1200px;
              top: 0;
          }
          .banner-swiper-pagination{
              bottom: 0;
              position: absolute;
              text-align: center;
              transform: translate3d(0, 0, 0);
              z-index: 10;
              transition: 300ms opacity;
              left: 50%;
              margin-left: -600px;
              background: rgba(0,0,0,.4);
              display: none;
              .pagination-bullet{
                  width: 132px;
                  height: 66px;
                  margin: 0 20px;
                  display: inline-block;
                  margin: 10px;
              }
          }
      }

      .index-news{
          .news-wrap{
              display: flex;
              .news-list{
                  width: 800px;
                  li{
                      a{
                          padding: 20px 0;
                          height: 200px;
                          box-sizing: border-box;
                          display: flex;
                          cursor: pointer;
                          .cover{
                              width: 285px;
                              height: 100%;
                              background: #000;
                              img{
                                  width: 100%;
                              }
                          }
                          .news-info{
                              flex: 1;
                              padding: 0 20px;
                              color: #333;
                              .name{
                                  font-size: 20px;
                                  line-height: 26px;
                                  font-weight: bold;
                                  display:-webkit-box;
                                  overflow:hidden;
                                  text-overflow:ellipsis;
                                  word-break:break-all;
                                  -webkit-box-orient:vertical; //子元素应该被水平或垂直排列
                                  -webkit-line-clamp:2;  //3行后显示省略号
                              }
                              .desc{
                                  font-size: 16px;
                                  line-height: 20px;
                                  height: 60px;
                                  margin-top: 10px;
                                  overflow: hidden;
                                  text-overflow: ellipsis;
                                  display: -webkit-box;
                                  -webkit-line-clamp: 3;
                                  -webkit-box-orient: vertical;
                              }
                              .author{
                                  font-size: 14px;
                                  color: #999;
                                  height: 34px;
                                  line-height: 34px;
                                  margin-top: 10px;
                                  border-top: 1px solid #e6e6e6;
                                  .time{
                                      float: right;
                                  }
                              }
                          }
                      }

                      &:hover{
                          a{
                              background: #f8f8f8;
                              .news-info{
                                  color: #7E0007;
                              }
                          }

                      }
                  }
              }
              .hot-recommend{
                  flex: 1;
                  margin-left: 20px;
                  .title{
                      font-size: 20px;
                      color: #333;
                      position: relative;
                      padding-left: 10px;
                      height: 20px;
                      line-height: 20px;
                      a{
                          font-size: 14px;
                          color: #333;
                          float: right;
                          font-weight: normal;
                      }
                      &:after{
                          content: "";
                          position: absolute;
                          top: 0;
                          left: 0;
                          display: inline-block;
                          width: 4px;
                          height: 20px;
                          background: #FF0000;
                      }
                  }
                  .number{
                      display: inline-block;
                      width: 20px;
                      height: 20px;
                      line-height: 20px;
                      text-align: center;
                      font-size: 14px;
                      color: #fff;
                      &.red{
                          background: #ff0000;
                      }
                      &.yellow{
                          background: #C8B9A6;
                      }
                  }
                  i{
                      display: inline-block;
                      width: 12px;
                      height: 12px;
                      background: url("../assets/images/fire.png") no-repeat center center;
                      background-size: auto 100%;
                      vertical-align: baseline;
                  }
                  .new-list{
                      background: #f8f8f8;
                      padding: 20px;
                      box-sizing: border-box;
                      .list{
                          li{
                              height: 40px;
                              border-bottom: 1px solid #E4E4E4;
                              line-height: 40px;
                              color: #333;
                              font-size: 14px;
                              &:hover{
                                  a{
                                      color: #7E0007;
                                  }

                              }
                              .item-title{
                                  height: 40px;
                                  line-height: 40px;
                                  overflow: hidden;
                                  white-space: nowrap;
                                  text-overflow: ellipsis;
                                  width: 200px;
                                  display: inline-block;
                                  vertical-align: middle;
                              }
                              a{
                                  display: block;
                              }
                              .views{
                                  float: right;
                                  color: #666;
                                  width:50px;
                                  display: inline-block;
                              }
                          }
                      }
                  }
                  .show-list{
                      background: #f8f8f8;
                      box-sizing: border-box;
                      margin-top: 40px;
                      padding-top: 20px;

                      .title{
                          margin: 0 20px;
                          padding-bottom: 20px;
                      }
                      .show-banner{
                          width: 380px;
                          height: 410px;
                          position: relative;
                          &:hover{
                              .swiper-button-prev, .swiper-button-next{
                                  display: block;
                              }
                          }
                          .swiper-container{
                              height: 100%;
                              img{
                                  width: 100%;
                                  height: auto;
                              }
                          }
                          .swiper-button-prev, .swiper-button-next{
                              outline: 0;
                              display: none;
                          }
                      }
                  }
              }
          }
      }

      .index-views{
          .views-wrap{
              display: flex;
              .views-list{
                  width: 800px;
                  .top{
                      display: flex;
                      height: 540px;
                      .top-left{
                          width: 460px;
                          &:hover{
                              .info{
                                  color: #7E0007;
                              }
                          }
                          .cover{
                              height: 350px;
                              overflow: hidden;
                              img{
                                  width: 120%;
                                  height: auto;
                              }
                          }
                          .top-left-info{
                              padding: 20px 0;
                              color: #333;
                              .name{
                                  font-size: 18px;
                                  height: 18px;
                                  line-height: 18px;
                                  overflow:hidden;
                                  white-space:nowrap;
                                  text-overflow:ellipsis;
                              }
                              .desc{
                                  font-size: 16px;
                                  height: 120px;
                                  line-height: 20px;
                                  padding-top: 8px;
                                  overflow: hidden;
                                  text-overflow: ellipsis;
                                  display: -webkit-box;
                                  -webkit-line-clamp: 6;
                                  -webkit-box-orient: vertical;
                              }
                          }
                      }
                      .top-right{
                          width: 280px;
                          margin-left: 40px;

                          .item{
                              height: 50%;
                              &:hover{
                                  .info{
                                      color: #7E0007;
                                  }
                              }
                              .cover{
                                  width: 280px;
                                  height: 160px;
                                  img{
                                      width: 100%;
                                      height: 100%;
                                  }
                              }
                              .item-info{
                                  padding: 20px 0;
                                  color: #333;
                                  .name{
                                      font-size: 18px;
                                      height: 18px;
                                      line-height: 18px;
                                      overflow:hidden;
                                      white-space:nowrap;
                                      text-overflow:ellipsis;
                                  }
                                  .desc{
                                      font-size: 16px;
                                      height: 40px;
                                      line-height: 20px;
                                      padding-top: 8px;
                                      overflow: hidden;
                                      text-overflow: ellipsis;
                                      display: -webkit-box;
                                      -webkit-line-clamp: 2;
                                      -webkit-box-orient: vertical;
                                  }
                              }
                          }
                      }
                  }
                  .bottom{
                      li{
                          display: inline-block;
                          width: 22.5%;
                          margin-right: 20px;
                          &:nth-child(4n){
                              margin-right: 0;
                          }
                          &:hover{
                              .name{
                                  color: #7E0007;
                              }
                          }
                          .cover{
                              height: 120px;
                              img{
                                  width: 100%;
                                  height: 100%;
                              }
                          }
                          .name{
                              height: 36px;
                              line-height: 36px;
                              font-size: 16px;
                              color: #333;
                              text-align: center;
                              overflow:hidden;
                              white-space:nowrap;
                              text-overflow:ellipsis;
                          }
                      }
                  }
              }
              .hot-views{
                  flex: 1;
                  margin-left: 30px;
                  .title{
                      font-size: 20px;
                      color: #333;
                      position: relative;
                      padding-left: 10px;
                      height: 20px;
                      line-height: 20px;
                      a{
                          font-size: 14px;
                          color: #333;
                          float: right;
                          font-weight: normal;
                      }
                      &:after{
                          content: "";
                          position: absolute;
                          top: 0;
                          left: 0;
                          display: inline-block;
                          width: 4px;
                          height: 20px;
                          background: #FF0000;
                      }
                  }
                  .number{
                      display: inline-block;
                      width: 20px;
                      height: 20px;
                      line-height: 20px;
                      text-align: center;
                      font-size: 14px;
                      color: #fff;
                      &.red{
                          background: #ff0000;
                      }
                      &.yellow{
                          background: #C8B9A6;
                      }
                  }
                  i{
                      display: inline-block;
                      width: 12px;
                      height: 12px;
                      background: url("../assets/images/fire.png") no-repeat center center;
                      background-size: auto 100%;
                      vertical-align: baseline;
                  }
                  .video-list{
                      width: 340px;
                      padding: 20px;
                      background: #f8f8f8;
                      box-sizing: border-box;
                      .list{
                          li{
                              a{
                                  display: flex;
                                  padding: 12px 0;
                                  border-bottom: 1px solid #E4E4E4;
                                  line-height: 40px;
                                  color: #333;
                                  font-size: 14px;
                                  position: relative;
                                  &:hover{
                                          color: #7E0007;
                                  }
                                  .cover{
                                      width: 114px;
                                      height: 86px;
                                      background: #fff;
                                      overflow: hidden;
                                      margin-left: 10px;
                                      img{
                                          width: 120%;
                                      }
                                  }
                                  .desc{
                                      margin-left: 10px;
                                      flex: 1;
                                      overflow: hidden;
                                      text-overflow:ellipsis;
                                      display: -webkit-box;
                                      -webkit-line-clamp: 2;
                                      -webkit-box-orient: vertical;
                                      line-height: 26px;
                                      height: 52px;
                                  }
                                  .views{
                                      position: absolute;
                                      right: 0;
                                      bottom: 0;
                                      width: 60px;
                                      display: inline-block;
                                  }
                              }

                          }
                      }

                  }
              }
          }
      }

      .index-about{
          height: 500px;
          background: url("../assets/images/aboutus-bg.jpg") no-repeat center center;
          background-size: 100% 100%;
          .common-title{
              color: #fff;
          }
          .plate{
              display: flex;
              li{
                  width: 25%;
                  text-align: center;
                  color: #fff;
                  .circle{
                      width: 100px;
                      height: 100px;
                      border-radius: 100%;
                      background: #eee;
                      margin: 0 auto;
                  }
                  .name{
                      font-size: 24px;
                      height: 64px;
                      line-height: 64px;
                  }
                  .txt{
                      width: 200px;
                      font-size: 14px;
                      line-height: 20px;
                      margin: 0 auto;
                  }
              }
          }
      }

      .index-partner{
          padding-bottom: 60px;
          .swiper-slide{
              display: inline-block;
              position: relative;
              img{
                  width: 100%;
                  height: 100%;
              }
              .name{
                  position: absolute;
                  bottom: 0;
                  left: 0;
                  font-size: 16px;
                  color: #333;
                  text-align: center;
                  width: 100%;
                  height: 16px;
                  line-height: 16px;
              }
          }
      }
   }
</style>



// WEBPACK FOOTER //
// src/components/Index.vue